import { TWO_D_REPORT_RIGHT_COLUMN_ID } from '../config';

export const scrollTop2DReportRightColumn = () => {
  document
    .getElementById(TWO_D_REPORT_RIGHT_COLUMN_ID)
    ?.scrollTo({ top: 0, behavior: 'smooth' });
};
